import React, { useState } from 'react';
import { useMap } from 'react-leaflet';
import L, { GeoJSON } from 'leaflet';
import ReviewModal from './ReviewModal';

const dogWalkIcon = new L.Icon({
  iconUrl: 'green-paw-marker.png', // make sure this path is correct
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const DogWalksLayer = () => {
  const [layer, setLayer] = useState<GeoJSON | null>(null);
  const [visible, setVisible] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedWalkId, setSelectedWalkId] = useState<string | null>(null);
  const map = useMap();

  const toggleLayer = async () => {
    if (!visible) {
      const response = await fetch('/data/map.geojson');
      const data = await response.json();

      const geoJsonLayer = L.geoJSON(data, {
        style: {
          color: 'green',
          weight: 4,
        },

        onEachFeature: (feature, layer) => {
          const walkId = feature.properties.id || 'Beacon Hill Dog Walk';

          // Determine start coordinate
          const coords = feature.geometry.type === 'LineString'
            ? feature.geometry.coordinates[0]
            : feature.geometry.type === 'Polygon'
              ? feature.geometry.coordinates[0][0]
              : null;

          if (coords) {
            const latlng = L.latLng(coords[1], coords[0]); // GeoJSON is [lng, lat]
            const marker = L.marker(latlng, { icon: dogWalkIcon });

            marker.on('click', async () => {
              setSelectedWalkId(walkId);
              setModalOpen(false);

              const res = await fetch(`/api/reviews/${walkId}`);
              const reviews = await res.json();

              const averageStars = reviews.length
                ? (
                    reviews.reduce((acc: number, r: { stars: number }) => acc + r.stars, 0) / reviews.length
                  ).toFixed(1)
                : 'No ratings yet';

              const latestReview = reviews.length
                ? `"${reviews[reviews.length - 1].comment}"`
                : 'Be the first to review!';

              const stars = Number(averageStars);
              const paws = '🐾'.repeat(Math.round(stars));

              const popupHtml = `
                <strong>${feature.properties.name}</strong><br>
                Distance: ${feature.properties.distance} mi<br>
                Time: ${feature.properties.duration_min} min<br>
                Rating: ${paws} (${averageStars})<br>
                <em>${latestReview}</em><br>
                <button id="review-${walkId}">Leave a Review</button>
              `;

              marker.bindPopup(popupHtml).openPopup();

              setTimeout(() => {
                const button = document.getElementById(`review-${walkId}`);
                if (button) {
                  button.onclick = () => {
                    setSelectedWalkId(walkId);
                    setModalOpen(true);
                  };
                }
              }, 0);
            });

            marker.addTo(map);
          }

          // Optional: allow clicking the path itself to open popup
          layer.on('click', () => {
            layer.openPopup();
          });
        }
      });

      geoJsonLayer.addTo(map);
      setLayer(geoJsonLayer);
      setVisible(true);
    } else {
      if (layer) {
        map.removeLayer(layer);
        setLayer(null);
      }
      setVisible(false);
    }
  };

  return (
    <div>
      <button
        onClick={toggleLayer}
        style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          zIndex: 1000,
          backgroundColor: 'white',
          padding: '8px 12px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        {visible ? 'Hide Dog Walks' : 'Show Dog Walks'}
      </button>
      {selectedWalkId && (
        <ReviewModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          walkId={selectedWalkId}
        />
      )}
    </div>
  );
};

export default DogWalksLayer;
